'use strict';

module.exports = {
    getElement: function() {
        return $('#' + this.widget.id);
    },

    createSelectors: Odigeo._.noop,

    updateFilter: Odigeo._.noop,

    render: Odigeo._.noop,

    initFilter: Odigeo._.noop,

    resetFilter: Odigeo._.noop,

    onFilter: Odigeo._.noop,

    bindEvents: Odigeo._.noop,
};
